/** Phân quyền — phiếu nhận hàng (Phase 24) */
export const PHIEU_NHAN_HANG_PERMISSION_CODES = {
  WEB_BH_PHIEU_NHAN_HANG_LIST: 'WEB_BH_PHIEU_NHAN_HANG_LIST',
  WEB_BH_PHIEU_NHAN_HANG_DETAIL: 'WEB_BH_PHIEU_NHAN_HANG_DETAIL',
  WEB_BH_PHIEU_NHAN_HANG_ADD: 'WEB_BH_PHIEU_NHAN_HANG_ADD',
  WEB_BH_PHIEU_NHAN_HANG_EDIT: 'WEB_BH_PHIEU_NHAN_HANG_EDIT',
  WEB_BH_PHIEU_NHAN_HANG_DELETE: 'WEB_BH_PHIEU_NHAN_HANG_DELETE',
  WEB_BH_PHIEU_NHAN_HANG_STATUS: 'WEB_BH_PHIEU_NHAN_HANG_STATUS',
  WEB_BH_PHIEU_NHAN_HANG_IMPORT: 'WEB_BH_PHIEU_NHAN_HANG_IMPORT',
  WEB_BH_PHIEU_NHAN_HANG_EXPORT: 'WEB_BH_PHIEU_NHAN_HANG_EXPORT',
} as const

export type PhieuNhanHangPermissionCode =
  (typeof PHIEU_NHAN_HANG_PERMISSION_CODES)[keyof typeof PHIEU_NHAN_HANG_PERMISSION_CODES]

export const PHIEU_NHAN_HANG_MUTATE_PERMISSIONS = [
  PHIEU_NHAN_HANG_PERMISSION_CODES.WEB_BH_PHIEU_NHAN_HANG_ADD,
  PHIEU_NHAN_HANG_PERMISSION_CODES.WEB_BH_PHIEU_NHAN_HANG_EDIT,
  PHIEU_NHAN_HANG_PERMISSION_CODES.WEB_BH_PHIEU_NHAN_HANG_DELETE,
  PHIEU_NHAN_HANG_PERMISSION_CODES.WEB_BH_PHIEU_NHAN_HANG_STATUS,
  PHIEU_NHAN_HANG_PERMISSION_CODES.WEB_BH_PHIEU_NHAN_HANG_IMPORT,
  PHIEU_NHAN_HANG_PERMISSION_CODES.WEB_BH_PHIEU_NHAN_HANG_EXPORT,
] as const
